exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list_once[data-v-7bc9c24d]{font-size:14px;padding:10px}.list_once .p[data-v-7bc9c24d]{font-size:16px;font-weight:700}.list_once .text[data-v-7bc9c24d]{margin:10px 0}.list_once .img[data-v-7bc9c24d]{max-width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7bc9c24d","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/dingtalkUse/helpCenterCom/2_tempSign.vue
// module id = PCA5
// module chunks = 54 242